import { aboutData } from '@/mocks/about';

export default function TestimonialSection() {
  return (
    <section id="testimonials" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-accent-600 font-medium">用户口碑</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            {aboutData.testimonials.title}
          </h2>
          <p className="text-sm text-foreground-500">
            {aboutData.testimonials.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {aboutData.testimonials.items.map((item) => (
            <div key={item.id} className="bg-white rounded-lg p-5 flex flex-col">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-200'}`}></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 flex-1">
                {item.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-100">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.username}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-950">{item.username}</p>
                  <p className="text-xs text-foreground-400">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}